import request from '@/utils/request'

/**
 * 获取前台志愿用户详情
 * @returns 
 */
export function getFrontExamUserDetail() {
  return request({
    url: '/front/user/examUserDetail/getExamUserInfo',
    method: 'post'
  })
}
